<template>
  <nav
    class="navbar"
    :class="[
      { 'navbar-expand-lg': expand },
      { 'navbar-transparent': transparent },
      //{ [`bg-gradient-success`]: type },
    ]"
  >
    <div :class="containerClasses">
      <slot name="brand">
        <!-- <router-link
          :to="$route.path"
          class="h4 mb-0 text-white text-uppercase d-none d-lg-inline-block"
        >
          {{ $route.name }}
        </router-link> -->
      </slot>
      <navbar-toggle-button
        v-if="isTogglable"
        :toggled="toggled"
        :target="contentId"
        @click.native.stop="toggled = !toggled"
      >
        <span class="navbar-toggler-icon"></span>
      </navbar-toggle-button>

      <div
        class="collapse navbar-collapse d-flex justify-content-end"
        :class="{ show: toggled }"
        :id="contentId"
        v-click-outside="closeMenu"
      >
        <slot :close-menu="closeMenu"></slot>
      </div>
    </div>
  </nav>
</template>
<script>
import NavbarToggleButton from './NavbarToggleButton'

export default {
  name: 'base-nav',
  components: {
    NavbarToggleButton,
  },
  props: {
    type: {
      type: String,
      default: 'success',
      description: 'Navbar type (e.g default, primary etc)',
    },
    title: {
      type: String,
      default: '',
      description: 'Title of navbar',
    },
    contentId: {
      type: [String, Number],
      default: Math.random().toString(),
      description:
        "Explicit id for the menu. By default it's a generated random number",
    },
    containerClasses: {
      type: [String, Object, Array],
      default: 'container-fluid',
    },
    transparent: {
      type: Boolean,
      default: false,
      description: 'Whether navbar is transparent',
    },
    expand: {
      type: String,
      default: 'lg',
      description: 'Breakpoint where nav should expand',
    },
    showToggleButton: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      toggled: false,
      isTogglable: this.showToggleButton,
    }
  },
  created() {
    if (
      window.location.href.indexOf('janoo.com.br') > 0 ||
      this.$route.query.hosted == 'janoo'
    ) {
      this.bcClasses += 'janoo_hosteded '
    }
  },
  methods: {
    closeMenu() {
      this.toggled = false
    },
  },
  computed: {
    classes() {
      let color = `bg-${this.type}`
      let classes = [
        { 'navbar-transparent': this.transparent },
        { [`navbar-expand-${this.expand}`]: this.expand },
      ]
      if (this.position) {
        classes.push(`navbar-${this.position}`)
      }
      if (!this.transparent) {
        classes.push(color)
      }
      return classes
    },
  },
}
</script>
<style></style>
